/**
 * axios取消请求
 */
export default defineStore('base/axios-abort', () => {
  // 取消请求控制器数组
  const abortControllerArray = ref([]);

  /**
   * 添加控制器
   * @param {AbortController} controller 取消控制器
   */
  const addController = (controller, view) => {
    abortControllerArray.value.push({
      view: view || 'empty',
      controller,
    });
  };

  /**
   * 取消所有请求
   */
  const cancelAll = () => {
    abortControllerArray.value.forEach((item) => {
      item.controller.abort();
    });
    abortControllerArray.value = [];
  };

  /**
   * 取消当前页面的请求
   */
  const cancelCurrentView = (view) => {
    abortControllerArray.value
      .filter((f) => f.view === view)
      .forEach((item) => {
        item.controller.abort();
      });
    abortControllerArray.value = abortControllerArray.value.filter(
      (f) => f.view !== view,
    );
  };

  return {
    abortControllerArray,

    addController,
    cancelAll,
    cancelCurrentView,
  };
});
